import { css } from 'linaria';
import React from 'react';
import { DropdownMenu } from '@jetshop/ui/DropdownMenu';
import { theme } from '../../Theme';

const menu = css`
  margin-bottom: 0;
  font-size: 0.875rem;

  [data-flight-dropdown-items] {
    border-top: 0;
    border-radius: 0;
    width: 100%;
    position: relative;
    border: 0;
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
  }
  [data-flight-dropdown-item] {
    overflow: hidden;
    display: block;
    padding: 0;
    text-align: left;
    background: transparent;
    display: flex;
    align-items: center;
    border: 0;
    padding: 10px 0;

    width: 46%;
    margin-right: 7%;
    font-size: 12px;
    &:nth-of-type(2n) {
      margin-right: 0;
    }

    :hover,
    :focus {
      background: white;
      color: ${theme.colors.blue};
      outline: none;
    }
  }

  [data-flight-dropdown-button] {
    font-size: 13px;
    text-transform: uppercase;
    padding: 1.2em 0;
    border: 0;
    border-bottom: 1px solid #dedede;
    width: 100%;
    text-align: left;
    background: ${theme.colors.white};
    font-weight: 300;
    outline: none;
    display: flex;
    align-items: center;

    svg {
      margin-left: auto;
    }

    :focus {
    }

    &[aria-expanded='true'] {

      .carot {
        transform: rotate(180deg);
      }
    }
  }
`;

export function FilterDropdownMenu(props) {
  return <DropdownMenu className={menu} {...props} />;
}
